import { DEFAULT_RACE_IMAGE } from '../config/constants';

/**
 * Transform backend Race object → CMS Event form shape (used in EventsManager)
 */
export const transformRaceToEvent = (race: any) => {
  const startDate = new Date(race.startDate);
  return {
    id: race.id,
    title: race.name,
    subtitle: race.subtitle || '',
    location: race.location,
    organizerId: race.organizerId || '',
    organizerName: race.organizer?.name || '',
    raceSeriesId: race.raceSeriesId || '',
    raceSeriesName: race.raceSeries?.name || '',
    date: startDate.toISOString().split('T')[0],
    time: startDate.toTimeString().slice(0, 5),
    image: race.imageUrl || '',
    status: new Date(race.startDate) > new Date() ? 'upcoming' : 'past',
    openRegistrationDate: race.openRegistrationDate ? race.openRegistrationDate.split('T')[0] : '',
    closeRegistrationDate: race.closeRegistrationDate ? race.closeRegistrationDate.split('T')[0] : '',
    description: race.description || '',
  };
};

/**
 * Transform CMS Event form shape → backend Race payload
 */
export const transformEventToRace = (eventData: any) => {
  const dateTime = `${eventData.date}T${eventData.time}:00Z`;
  return {
    name: eventData.title,
    subtitle: eventData.subtitle,
    location: eventData.location,
    organizerId: eventData.organizerId,
    raceSeriesId: eventData.raceSeriesId || null,
    startDate: dateTime,
    imageUrl: eventData.image,
    description: eventData.description,
    openRegistrationDate: eventData.openRegistrationDate ? `${eventData.openRegistrationDate}T00:00:00Z` : null,
    closeRegistrationDate: eventData.closeRegistrationDate ? `${eventData.closeRegistrationDate}T23:59:59Z` : null,
  };
};
